module.exports = __webpack_public_path__ + "img/p1.34bf23b6.png";